import { render, staticRenderFns } from "./StudySetDuplicateFooter.vue?vue&type=template&id=a964abc2&scoped=true&"
import script from "./StudySetDuplicateFooter.vue?vue&type=script&lang=js&"
export * from "./StudySetDuplicateFooter.vue?vue&type=script&lang=js&"
import style0 from "./StudySetDuplicateFooter.vue?vue&type=style&index=0&id=a964abc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a964abc2",
  null
  
)

export default component.exports